/**
 * @module mapbs.components.realestateinformation.service.realestateinformationservice
 */

import angular from 'angular';

const moduleRealestateinformationService = angular.module('mapbsRealestateinformationServiceModule', []);

class RealestateinformationserviceController {
    /** @constructor
   * @struct
   * @param {angular.$injector} $injector Main injector.
   * @param {angular.$http} $http
   * @param {angular.$timeout} $timeout Angular timeout service.

   * @param {angular.$q} $q
   */
    constructor($injector, $http, $timeout, $q) {
        /** @type {string} */
        this.realestateinfoBaseUrl = $injector.get('realestate_information_url');
        this.realestateinfoApikey = $injector.get('realestate_information_apikey');

        this.http = $http;
        this.timeout = $timeout;
        this.q = $q;

        /** @type {?angular.$q.Deferred} @private */
        this.requestCanceler_ = null;


        /** @type {string} */
        this.errormessage = '';

        /** @type {?angular.$q.Deferred} @private */
        this.promise = null;

    }

    /**
   * @param {string} egrid
   * @returns {angular.$q.Promise<Any>}
   */

    getRealestateInfo(egrid) {
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'text/xml; charset=UTF-8',
                'apikey': `${this.realestateinfoApikey}`,
            }
        };
        return fetch(`${this.realestateinfoBaseUrl}realestatesinformation?ids=${egrid}&withgeometry=true`, options)
            .then((response) => {
                return response;
            });
    }

}

moduleRealestateinformationService.service('mapbsRealestateinformationService', RealestateinformationserviceController);

export default moduleRealestateinformationService;
